import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Summary", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  class: "col-md-9 dx-item-content dx-toolbar-item-content",
  style: {"min-width":"350px"}
}
const _hoisted_4 = {
  role: "group",
  class: "dx-buttongroup dx-widget",
  tabindex: "0"
}
const _hoisted_5 = { class: "dx-buttongroup-wrapper dx-widget dx-collection" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-chevronprev" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-shape-standard dx-scheduler-navigator-caption",
  role: "button",
  "aria-label": ""
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-chevronnext" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-check" }),
  /*#__PURE__*/_createTextVNode(" Today ")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "table table-hover mt-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", { style: {"color":"red"} }, [
  /*#__PURE__*/_createElementVNode("th", null, "Week days"),
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Age"),
  /*#__PURE__*/_createElementVNode("th", null, "Inventory"),
  /*#__PURE__*/_createElementVNode("th", null, "Check-out/SOC"),
  /*#__PURE__*/_createElementVNode("th", null, "Check-In"),
  /*#__PURE__*/_createElementVNode("th", null, "Other"),
  /*#__PURE__*/_createElementVNode("th", null, "Total to hit KPI"),
  /*#__PURE__*/_createElementVNode("th", null, "PVs"),
  /*#__PURE__*/_createElementVNode("th", null, "Feedback")
], -1)
const _hoisted_15 = { style: {"color":"red"} }
const _hoisted_16 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1)

import { computed, inject, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import moment from "moment-timezone";

import { DxDateBox } from "devextreme-vue/date-box";
import { Booking, Report } from '@/models';

export default /*#__PURE__*/_defineComponent({
  __name: 'Summary',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const store = useStore();
const _currentdate = computed(() => store.getters["diary/currentdate"]);
const todaymoment = moment().utc().startOf('day');

const summaryArray = ref<SummaryData[]>([]);

const setCurrentdate = (currentdate: Date) => {
  store.commit("diary/setCurrentdate", currentdate);
};

const getBookingsforQCSummary = (payload?: { date?: string; }, p0?: () => void) => {
  return store.dispatch("diary/getBookingsforQCSummary", payload);
};

const currentdate = computed({
  get: () => _currentdate.value,
  set: (val:Date) => {
    setCurrentdate(val)
    bookingforQCsummary();
  },
});


const formatWeekDay = (date: Date) => moment(date).format("dddd");
const formatdate = (date: Date) => moment(date).format("DD-MM-YYYY");

const prevdate = () => {
  isCalendarSelected.value = true;
  currentdate.value = moment(currentdate.value)
    .utc()
    .subtract(1, "days")
    .toDate();
  bookingforQCsummary();
};

const nextdate = () => {
  isCalendarSelected.value = true;
  currentdate.value = moment(currentdate.value).utc().add(1, "days").toDate();
  bookingforQCsummary();
};

const today = () => {
  isCalendarSelected.value = false;
  currentdate.value = moment().utc().toDate();
  bookingforQCsummary();
};

const formatDate = (date: Date) => {
  return moment(date).format("DD-MM-YYYY");
};

const dformatDate = (date: Date) => {
  return moment(date).format("DD/MM/YYYY");
};

class SummaryData {
  weekdays?: string;
  date?: string;
  age?: string;
  Inventory?: number;
  CoSOC: number;
  ci: number;
  other: number;
  pv: number;
  feedback: number;
  kpi: number;
}

const calculateSummaryData = (bookingList: Booking[], date: Date) => {
  const jobtypeArray = ["inventory", "checkin", "soc", "property visit", "checkout"];
  let cosocdata = bookingList.filter((b: Booking) => {
    return b.jobtype === ('checkout' || b.jobtype === 'soc') && b.bookingdate === dformatDate(date);
  });
  let checkindata = bookingList.filter((b: Booking) => {
    return b.jobtype === 'checkin' && b.bookingdate === dformatDate(date);
  });
  let inventorydata = bookingList.filter((b: Booking) => {
    return b.jobtype === 'inventory' && b.bookingdate === dformatDate(date);
  });
  let pvdata = bookingList.filter((b: Booking) => {
    return b.jobtype === 'property visit' && b.bookingdate === dformatDate(date);
  });
  let otherdata = bookingList.filter((b: Booking) => {
    return !jobtypeArray.includes(b.jobtype) && b.bookingdate === dformatDate(date);
  });
  let feedbackstatus = bookingList.filter((b: Booking) => {
    return b.report.feedbackstatus === 'Received' && b.bookingdate === dformatDate(date);
  });

  let data = new SummaryData();
  data.CoSOC = cosocdata.length;
  data.ci = checkindata.length;
  data.Inventory = inventorydata.length;
  data.pv = pvdata.length;
  data.other = otherdata.length;
  data.feedback = feedbackstatus.length;
  return data;
}

onMounted(() => {
  bookingforQCsummary();
});

// watch(currentdate, () => {
//   bookingforQCsummary();
// });


const bookingforQCsummary = () => {
  getBookingsforQCSummary({ date: formatDate(currentdate.value) }, () => { }).then((bookingList: Booking[]) => {
    summaryArray.value = [];
    console.log("currentdate ", currentdate.value);

    const start = moment(currentdate.value).subtract(9, "days");
    const end = moment(currentdate.value).add(4, "days");
    const dateRange = [];

    for (let m = start; m.isBefore(end); m.add(1, 'days')) {
      dateRange.push(m.toDate());
    }
    for (let i = 0; i < dateRange.length; i++) {
      let obj = calculateSummaryData(bookingList, dateRange[i]);
      let data = new SummaryData();
      let date = dateRange[i];
      data.weekdays = formatWeekDay(date);
      data.date = formatdate(date);
      data.CoSOC = obj.CoSOC;
      data.ci = obj.ci;
      data.Inventory = obj.Inventory;
      data.pv = obj.pv;
      data.other = obj.other;
      data.feedback = obj.feedback;
      summaryArray.value.push(data);
    }
  });
}

const isCalendarSelected = ref(false);

const findAge = (date: string) => {
      const dateMoment = moment.tz(date, "DD-MM-YYYY", "UTC");
      const todayMoment = moment().utc().startOf('day');
      const currentMoment = moment(currentdate.value).utc().startOf('day');

      if (dateMoment.isSame(todayMoment, 'day') && !isCalendarSelected.value) {
        return "Today";
      } else if (dateMoment.isSame(currentMoment, 'day') && isCalendarSelected.value) {
        return "Selected Day";
      } else {
        let diffInDays = 0;
        let mom = moment(currentdate.value).utc().clone();

        if (dateMoment.isSameOrBefore(mom)) {
          while (mom.isAfter(dateMoment, 'day')) {
            mom.add(-1, 'days');
            const dayOfWeek = mom.day();
            if (dayOfWeek !== 6 && dayOfWeek !== 0) { // Skip Saturday (6) and Sunday (0)
              diffInDays++;
            }
          }
        } else {
          while (mom.isBefore(dateMoment, 'day')) {
            mom.add(1, 'days');
            const dayOfWeek = mom.day();
            if (dayOfWeek !== 6 && dayOfWeek !== 0) { // Skip Saturday (6) and Sunday (0)
              diffInDays++;
            }
          }
          return `+${diffInDays}`;
        }

        return  diffInDays.toString();
      }
    };

const totalInventory = computed(() => {
  return summaryArray.value.slice(0, 8).reduce((total, item) => total + (item.Inventory || 0), 0);
});

const totalCoSOC = computed(() => {
  return summaryArray.value.slice(0, 8).reduce((total, item) => total + (item.CoSOC || 0), 0);
});

const totalCheckIn = computed(() => {
  return summaryArray.value.slice(0, 8).reduce((total, item) => total + (item.ci || 0), 0);
});

const totalOther = computed(() => {
  return summaryArray.value.slice(0, 8).reduce((total, item) => total + (item.other || 0), 0);
});

const totalPV = computed(() => {
  return summaryArray.value.slice(0, 8).reduce((total, item) => total + (item.pv || 0), 0);
});

const totalfeedback = computed(() => {
  return summaryArray.value.slice(0, 8).reduce((total, item) => total + (item.feedback || 0), 0);
});

const totalToHitKPI = computed(() => {
  return totalInventory.value + totalCoSOC.value + totalCheckIn.value + totalOther.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-buttongroup-first-item dx-shape-standard dx-scheduler-navigator-previous",
              role: "button",
              "aria-label": "chevronprev",
              onClick: prevdate
            }, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(DxDateBox), {
                modelValue: currentdate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentdate).value = $event)),
                "display-format": "EEEE dd MMMM yyyy",
                type: "date",
                "picker-type": "calendar",
                "apply-value-mode": "instantly",
                class: "datebox",
                calendarOptions: { firstDayOfWeek: 1 }
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", {
              class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-shape-standard dx-scheduler-navigator-next",
              role: "button",
              "aria-label": "chevronnext",
              onClick: nextdate
            }, _hoisted_10),
            _createElementVNode("div", {
              class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-buttongroup-last-item dx-shape-standard today-button",
              role: "button",
              "aria-label": "today",
              onClick: today
            }, _hoisted_12)
          ])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryArray.value, (data, prepdata) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: prepdata }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(data.weekdays), 1),
              _createElementVNode("td", null, _toDisplayString(data.date), 1),
              _createElementVNode("td", _hoisted_15, _toDisplayString(findAge(data.date)), 1),
              _createElementVNode("td", null, _toDisplayString(data.Inventory), 1),
              _createElementVNode("td", null, _toDisplayString(data.CoSOC), 1),
              _createElementVNode("td", null, _toDisplayString(data.ci), 1),
              _createElementVNode("td", null, _toDisplayString(data.other), 1),
              _createElementVNode("td", null, _toDisplayString(), 1),
              _createElementVNode("td", null, _toDisplayString(data.pv), 1),
              _createElementVNode("td", null, _toDisplayString(data.feedback), 1)
            ]),
            (prepdata === 7)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(totalInventory.value), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(totalCoSOC.value), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(totalCheckIn.value), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(totalOther.value), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(totalToHitKPI.value), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(totalPV.value), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(totalfeedback.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ]))
}
}

})